import { render, staticRenderFns } from "./OrderhuizongDetails.vue?vue&type=template&id=7f0d0f7b&scoped=true"
import script from "./OrderhuizongDetails.vue?vue&type=script&lang=js"
export * from "./OrderhuizongDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderhuizongDetails.vue?vue&type=style&index=0&id=7f0d0f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0d0f7b",
  null
  
)

export default component.exports